import script from "./AnalysisPane.vue?vue&type=script&lang=ts&setup=true"
export * from "./AnalysisPane.vue?vue&type=script&lang=ts&setup=true"

import "./AnalysisPane.vue?vue&type=style&index=0&id=ad613a60&lang=scss"

const __exports__ = script;

export default __exports__
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QSeparator});
